"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _hubspotUrlinator = _interopRequireDefault(require("hubspot.urlinator.Url"));

var twitterShareBaseURL = 'https://twitter.com/intent/tweet';
var facebookShareBaseURL = 'http://www.facebook.com/share.php';
var linkedInShareBaseURL = 'https://www.linkedin.com/shareArticle';

var ShareIcons =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ShareIcons, _React$Component);

  function ShareIcons() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ShareIcons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShareIcons)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getShareText = function () {
      return _I18n.default.text('results.share.shareText');
    };

    _this.getTwitterShareUrl = function (currentUrl) {
      var url = new _hubspotUrlinator.default(twitterShareBaseURL);
      url.pushParam('text', _this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('hashtags', _I18n.default.text('results.share.shareHashtag'));
      return url.href;
    };

    _this.getFacebookShareUrl = function (currentUrl) {
      var url = new _hubspotUrlinator.default(facebookShareBaseURL);
      url.pushParam('title', _this.getShareText());
      url.pushParam('u', currentUrl);
      return url.href;
    };

    _this.getLinkedInShareUrl = function (currentUrl) {
      var url = new _hubspotUrlinator.default(linkedInShareBaseURL);
      url.pushParam('title', _this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('summary', _this.getShareText());
      return url.href;
    };

    return _this;
  }

  (0, _createClass2.default)(ShareIcons, [{
    key: "render",
    value: function render() {
      var currentUrl = location.href;
      return _react.default.createElement("div", {
        className: "share-icons"
      }, _react.default.createElement("a", {
        className: "icon icon-twitter",
        href: this.getTwitterShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }), _react.default.createElement("a", {
        className: "icon icon-facebook",
        href: this.getFacebookShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }), _react.default.createElement("a", {
        className: "icon icon-linkedin",
        href: this.getLinkedInShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer"
      }));
    }
  }]);
  return ShareIcons;
}(_react.default.Component);

exports.default = ShareIcons;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ShareIcons.js
// module id = 308
// module chunks = 0